export default __webpack_public_path__ + "eb9fb1ccc6cd00f2f85b964beee6861e.svg";